import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Typography, Container, Divider } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import { ACTIONS as SEARCH_ACTIONS } from "../../../redux/search";
import useSearch from "../../../hooks/useSearch";
import InputField from "../../../components/input-field";

import UserList from "../../../components/user-list";
import StyledSearchHomePage from "./styles";
import { filteredData, query } from "./mocks";

const SearchHomePage = () => {
  useSearch();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { filteredData, query, data } = useSelector((state) => state.search);

  const onUserClick = (userProps) => {
    const { uid } = userProps;
    navigate(`/search/profiles/${uid}`);
  };

  const onInputChangeHandler = (text) => {};

  useEffect(() => {
    dispatch(SEARCH_ACTIONS.getSearcherInfo());
  }, []);

  return (
    <StyledSearchHomePage>
      <div className="search-home-page">
        {/* <div className="input-searcher">
          <InputField
            onChange={onInputChangeHandler}
            icon={() => <SearchIcon sx={{ fill: "grey" }} />}
            noSendButton={true}
          />
        </div> */}
        <UserList users={filteredData} onUserClick={onUserClick} />
      </div>
    </StyledSearchHomePage>
  );
};

export default SearchHomePage;
